import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const STAFF_SETTING = `${API_ENDPOINT}/api/identity/users`;

const staffSettingApi = {
   gets: (params) => {
      return axiosClient.get(STAFF_SETTING, { params });
   },
   inviteMember: (data) => {
      return axiosClient.post(STAFF_SETTING, data);
   },
   addStoreMember: (id, data) => {
      return axiosClient.post(
         `${API_ENDPOINT}/api/app/cms/store-member`,
         data
      );
   },
   getStaffSettingStoreDetail: (id) => {
      return axiosClient.get(
         `${API_ENDPOINT}/api/app/cms/store-member`,
         {}
      );
   },
   updateStaffRole: (userId, data) => {
      return axiosClient.put(`${API_ENDPOINT}/api/identity/users/${userId}/roles`, data);
   },
   getStaffSettingRoleDetail: (id) => {
      return axiosClient.get(`${STAFF_SETTING}/${id}/group-role`);
   },
   getPagedStaffList: (params) => {
      return axiosClient.get(`${API_ENDPOINT}/api/identity/users`, {});
   },
   getStaffById: (id) => {
      return axiosClient.get(`${API_ENDPOINT}/api/identity/users/${id}`, {});
   },
   getStoreMember: (userId, storeId) => {
      return axiosClient.get(
         `${API_ENDPOINT}/api/app/cms/store-member`,
         {
            queries: [
               {
                  fieldName: "userId",
                  value: userId,
               },
               {
                  fieldName: "storeId",
                  value: storeId,
               },
            ],
         }
      );
   },
   deleteStoreMemberById(id) {
      return axiosClient.delete(`${API_ENDPOINT}/api/app/cms/store-member/${id}`);
   },
};

export default staffSettingApi;
